import { useUnit } from 'effector-react';
import { CopyPlus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip } from '../../shared/ui';
import { saveCopyRequested } from './model';

export function SaveCopyButton({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  const save = useUnit(saveCopyRequested);
  return (
    <Tooltip content={t('viewer.saveCopyHint')}>
      <Button
        size="sm"
        variant={compact ? 'ghost' : 'secondary'}
        leadingIcon={<CopyPlus />}
        onClick={() => {
          save();
        }}
      >
        {t('viewer.saveCopy')}
      </Button>
    </Tooltip>
  );
}
